export const TOGGLE_RIGHT2_PANEL = "TOGGLE_RIGHT2_PANEL";
export const TOGGLE_LEFT1_PANEL = "TOGGLE_LEFT1_PANEL";

export interface ToggleRight2Panel {
    type: typeof TOGGLE_RIGHT2_PANEL;
    payload: { data: boolean };
}

export interface ToggleLeft1Panel {
    type: typeof TOGGLE_LEFT1_PANEL;
    payload: { data: boolean };
}

export interface SidebarStateInterface {
    isLeftSideBar1Open: boolean;
    isRightSideBar2Open: boolean;
}

export type SidebarTypes = ToggleRight2Panel | ToggleLeft1Panel;
